export default {
  // Generic
  "generic.add": "Добавить",
  "generic.cancel": "Отменить",

  // BlockType
  "components.controls.blocktype.h1": "Заголовок 1",
  "components.controls.blocktype.h2": "Заголовок 2",
  "components.controls.blocktype.h3": "Заголовок 3",
  "components.controls.blocktype.h4": "Заголовок 4",
  "components.controls.blocktype.h5": "Заголовок 5",
  "components.controls.blocktype.h6": "Заголовок 6",
  "components.controls.blocktype.blockquote": "Цитата",
  "components.controls.blocktype.code": "Код",
  "components.controls.blocktype.blocktype": "Форматирование",
  "components.controls.blocktype.normal": "Обычный",

  // Color Picker
  "components.controls.colorpicker.colorpicker": "Выбор цвета",
  "components.controls.colorpicker.text": "Текст",
  "components.controls.colorpicker.background": "Фон",

  // Embedded
  "components.controls.embedded.embedded": "Встраивание",
  "components.controls.embedded.embeddedlink": "Ссылка в iFrame",
  "components.controls.embedded.enterlink": "Вставьте ссылку",

  // Emoji
  "components.controls.emoji.emoji": "Эмодзи",

  // FontFamily
  "components.controls.fontfamily.fontfamily": "Шрифт",

  // FontSize
  "components.controls.fontsize.fontsize": "Размер шрифта",

  // History
  "components.controls.history.history": "История",
  "components.controls.history.undo": "Отменить",
  "components.controls.history.redo": "Вернуть",

  // Image
  "components.controls.image.image": "Изображение",
  "components.controls.image.fileUpload": "Файлы",
  "components.controls.image.byURL": "URL",
  "components.controls.image.dropFileText":
    "Переместите в эту область файлы или кликните для загрузки",

  // Inline
  "components.controls.inline.bold": "Жирный",
  "components.controls.inline.italic": "Курсив",
  "components.controls.inline.underline": "Подчеркивание",
  "components.controls.inline.strikethrough": "Зачеркивание",
  "components.controls.inline.monospace": "Monospace",
  "components.controls.inline.superscript": "Верхний индекс",
  "components.controls.inline.subscript": "Нижний индекс",

  // Link
  "components.controls.link.linkTitle": "Текст",
  "components.controls.link.linkTarget": "Адрес ссылки",
  "components.controls.link.linkTargetOption": "Открывать в новом окне",
  "components.controls.link.link": "Ссылка",
  "components.controls.link.unlink": "Убрать ссылку",

  // List
  "components.controls.list.list": "Список",
  "components.controls.list.unordered": "Неупорядоченный",
  "components.controls.list.ordered": "Упорядоченный",
  "components.controls.list.indent": "Отступ",
  "components.controls.list.outdent": "Выступ",

  // Remove
  "components.controls.remove.remove": "Удалить",

  // TextAlign
  "components.controls.textalign.textalign": "Выравнивание текста",
  "components.controls.textalign.left": "Слева",
  "components.controls.textalign.center": "По центру",
  "components.controls.textalign.right": "Справа",
  "components.controls.textalign.justify": "Выравнить"
};
